// extracted by mini-css-extract-plugin
module.exports = {"boxLists":"_3Zve1P26FsB3tky8-F2Tt3","list":"_3DUR9gYHpoLT1B-jf8QEyG","name":"ZGVFwpp7qCCWxMZ_TuOk9","type":"_20pVYPGJtT5GPIRwxTXr7x","manage":"n9PeTuKBN9a94lEoK1TB8"};